// src/utils/analytics.ts
export const GA_TRACKING_ID = process.env.REACT_APP_PUBLISH_TRACKING_ID || "G-RGH9Q2DL03";

let isGAInitialized = false;

// Initialiser Google Analytics
export const initGA = (): Promise<void> => {
    return new Promise((resolve) => {
        if (!GA_TRACKING_ID) {
            console.warn('GA_TRACKING_ID non défini');
            resolve();
            return;
        }

        if (isGAInitialized) {
            resolve();
            return;
        }

        // Initialiser dataLayer
        (window as any).dataLayer = (window as any).dataLayer || [];

        // Fonction gtag
        function gtag(...args: any[]) {
            (window as any).dataLayer.push(arguments);
        }

        // Assigner gtag à window immédiatement
        (window as any).gtag = gtag;

        // Charger le script Google Analytics
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;

        script.onload = () => {
            // Configuration initiale après le chargement du script
            const gtagFunc = (window as any).gtag;
            if (typeof gtagFunc === 'function') {
                gtagFunc('js', new Date());
                gtagFunc('config', GA_TRACKING_ID!, {
                    page_title: document.title,
                    page_location: window.location.href,
                    send_page_view: false // On gère manuellement les page views
                });
            }

            isGAInitialized = true;
            console.log('Google Analytics initialisé avec ID:', GA_TRACKING_ID);
            resolve();
        };

        script.onerror = () => {
            console.error('Erreur lors du chargement de Google Analytics');
            resolve();
        };

        document.head.appendChild(script);
    });
};

// Vérifier si GA est disponible
const isGAReady = (): boolean => {
    const gtagFunc = (window as any).gtag;
    return !!(GA_TRACKING_ID && typeof gtagFunc === 'function' && isGAInitialized);
};

// Tracker les pages vues
export const trackPageView = (url: string, title?: string) => {
    if (!isGAReady()) {
        console.debug('GA pas encore prêt pour trackPageView:', url);
        return;
    }

    const gtagFunc = (window as any).gtag;

    gtagFunc('config', GA_TRACKING_ID!, {
        page_path: url,
        page_title: title || document.title,
    });

    // Envoyer l'événement page_view
    gtagFunc('event', 'page_view', {
        page_path: url,
        page_title: title || document.title,
    });

    console.debug('Page view tracked:', url);
};

// Tracker des événements personnalisés
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
    if (!isGAReady()) {
        console.debug('GA pas encore prêt pour trackEvent:', action);
        return;
    }

    const gtagFunc = (window as any).gtag;

    gtagFunc('event', action, {
        event_category: category,
        event_label: label,
        value: value,
    });

    console.debug('Event tracked:', action, category, label);
};

// Tracker les clics sur des éléments spécifiques
export const trackClick = (elementName: string, location?: string) => {
    trackEvent('click', 'engagement', `${elementName}${location ? ` - ${location}` : ''}`);
};

// Tracker les formulaires
export const trackFormSubmit = (formName: string) => {
    trackEvent('form_submit', 'engagement', formName);
};